<template>
  <div
    class="fcode-box"
    :class="{
      content: !isGuide,
      guide: isGuide,
    }"
  >
    <div class="head">
      <div class="title-select" v-if="robotList.length > 1 && !isGuide">
        <el-select
          v-model="currentTicket"
          placeholder="请选择"
          size="medium"
          @change="robotChange"
        >
          <el-option
            v-for="item in robotList"
            :key="item.ticket"
            :label="`${item.label}${item.huyaUserName ? `-${item.huyaUserName}` : ''}`"
            :value="item.ticket"
          ></el-option>
        </el-select>
      </div>
      <div
        class="input-box"
        :class="{
          checked: fcodeInputComplete,
        }"
      >
        <span class="hd">{{ pName }}</span>
        <span class="ft">
          <i class="clear" id="clear-fcode" @click="FCode = ''"></i>
        </span>
        <input
          type="text"
          v-model.trim="FCode"
          autocomplete="off"
          placeholder="请贴入F码..."
          id="use-fcode"
        />
      </div>
      <!-- <el-form class="input-fcode">
        <el-input
          v-model="FCode"
          autocomplete="off"
          placeholder="请输入F码..."
          clearable
          @blur="getFCodeName"
          @input="checkInput"
        >
          <template slot="prepend">
            <i class="fa-barcode" v-if="!pName"></i>
            <span v-else>{{pName}}</span>
          </template>
        </el-input>
      </el-form> -->
      <div class="actions">
        <button class="button" @click="actionFCode">使用F码</button>
      </div>
    </div>
    <div class="body">
      <div class="title" v-if="isGuide">
        <span>购买F码</span>
        <small v-if='canFree' @click="tryOut" >领取体验版</small>
      </div>
      <div class="block">
        <div class="pc-block">
          <div class="title-line">
            <span>电脑版</span>
          </div>
          <div class="cards client">
            <div
              class="card week pay-client-week"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_week',
                      price: 990,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·周卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">周卡</div>
              <div class="price">￥9.9</div>
              <div class="info">可用7天</div>
            </div>
            <div
              class="card month pay-client-month"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_month',
                      price: 2990,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·月卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">月卡</div>
              <div class="price">￥29.9</div>
              <div class="info">可用30天</div>
              <div class="discount">
                ≈
                <strong>7</strong>折
              </div>
            </div>
            <div
              class="card quarter pay-client-quarter"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_season',
                      price: 8900,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·季卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">季卡</div>
              <div class="price">￥89</div>
              <div class="info">
                可用90天
                <br />
              </div>
              <div class="give">
                <strong>+送30天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>5.5</strong>折
              </div>
            </div>
            <div
              class="card year pay-client-year"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_year',
                      price: 32800,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·年卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">年卡</div>
              <div class="price">￥328</div>
              <div class="info">
                可用365天
                <br />
              </div>
              <div class="give">
                <strong>+送120天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>5</strong>折
              </div>
            </div>
          </div>
          <div class="tips" v-if="isWeixin" @click="orderPayWeixinGuideShow">
            想用花呗分期请在浏览器里打开
          </div>
        </div>
        <div class="mb-block">
          <div class="title-line">
            <span>手机版</span>
          </div>
          <div class="cards cloud">
            <div
              class="card week pay-cloud-week"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_week',
                      price: 1990,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·周卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">周卡</div>
              <div class="price">￥19.9</div>
              <div class="info">可用7天</div>
            </div>
            <div
              class="card month pay-cloud-month"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_month',
                      price: 6990,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·月卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">月卡</div>
              <div class="price">￥69.9</div>
              <div class="info">可用30天</div>
              <div class="discount">
                ≈
                <strong>8.5</strong>折
              </div>
            </div>
            <div
              class="card quarter pay-cloud-quarter"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_season',
                      price: 20900,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·季卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">季卡</div>
              <div class="price">￥209</div>
              <div class="info">
                可用90天
                <br />
              </div>
              <div class="give">
                <strong>+送30天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>6</strong>折
              </div>
            </div>
            <div
              class="card year pay-cloud-year"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_year',
                      price: 76800,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·年卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">年卡</div>
              <div class="price">￥768</div>
              <div class="info">
                可用365天
                <br />
              </div>
              <div class="give">
                <strong>+送120天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>5.5</strong>折
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="mb-block">
          <div class="title-line">
            <span>电脑版</span>
          </div>
          <div class="cards client">
            <div
              class="card week pay-client-week"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_week',
                      price: 990,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·周卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">周卡</div>
              <div class="price">￥9.9</div>
              <div class="info">可用7天</div>
            </div>
            <div
              class="card month pay-client-month"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_month',
                      price: 2990,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·月卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">月卡</div>
              <div class="price">￥29.9</div>
              <div class="info">可用30天</div>
              <div class="discount">
                ≈
                <strong>7</strong>折
              </div>
            </div>
            <div
              class="card quarter pay-client-quarter"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_season',
                      price: 8900,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·季卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">季卡</div>
              <div class="price">￥89</div>
              <div class="info">
                可用90天
                <br />
              </div>
              <div class="give">
                <strong>+送30天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>5.5</strong>折
              </div>
            </div>
            <div
              class="card year pay-client-year"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'b_year',
                      price: 32800,
                    },
                  ],
                  timeAdd: '0',
                  name: '电脑版·年卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">年卡</div>
              <div class="price">￥328</div>
              <div class="info">
                可用365天
                <br />
              </div>
              <div class="give">
                <strong>+送120天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>5</strong>折
              </div>
            </div>
          </div>
        </div>
        <div class="pc-block">
          <div class="title-line">
            <span>手机版</span>
          </div>
          <div class="cards cloud">
            <div
              class="card week pay-cloud-week"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_week',
                      price: 1990,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·周卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">周卡</div>
              <div class="price">￥19.9</div>
              <div class="info">可用7天</div>
            </div>
            <div
              class="card month pay-cloud-month"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_month',
                      price: 6990,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·月卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">月卡</div>
              <div class="price">￥69.9</div>
              <div class="info">可用30天</div>
              <div class="discount">
                ≈
                <strong>8.5</strong>折
              </div>
            </div>
            <div
              class="card quarter pay-cloud-quarter"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_season',
                      price: 20900,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·季卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">季卡</div>
              <div class="price">￥209</div>
              <div class="info">
                可用90天
                <br />
              </div>
              <div class="give">
                <strong>+送30天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>6</strong>折
              </div>
            </div>
            <div
              class="card year pay-cloud-year"
              @click="
                handleRenew(1, {
                  products: [
                    {
                      pkey: 'm_year',
                      price: 76800,
                    },
                  ],
                  timeAdd: '0',
                  name: '手机版·年卡',
                  payType: 'add',
                })
              "
            >
              <div class="name">年卡</div>
              <div class="price">￥768</div>
              <div class="info">
                可用365天
                <br />
              </div>
              <div class="give">
                <strong>+送120天</strong>
              </div>
              <div class="huabei"></div>
              <div class="discount">
                ≈
                <strong>5.5</strong>折
              </div>
            </div>
          </div>
          <div class="tips" v-if="isWeixin" @click="orderPayWeixinGuideShow">
            想用花呗分期请在浏览器里打开
          </div>
        </div>
      </div>
    </div>
    <div class="exit-wx">
      <el-link type="primary" @click="logout">更换账号></el-link>
      <span>登错账号了？</span>
    </div>
    <!-- <pay-box
      ref="dialogpay"
      @dialogClose="dialogPayClose"
      @payCompleted="payCompleted"
    ></pay-box> -->
  </div>
</template>

<script>
import {
  createWechatPayOrder,
  createWechatPay,
  consumeFCode,
  getFCode,
  checkFcodeOrder,
  getFCodeName,
  userInfo,
  setGuide,
  getThreeDayVip
} from "@/api/index";
import { Message } from "element-ui";
import payBox from "@/components/payBox";
import { mapState, mapActions } from "vuex";
let inputFcodeTimer = null;

export default {
  props: {
    isGuide: {
      type: Boolean,
      default: true,
    },
    robotList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ticket: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      FCode: "",
      pName: "",
      FCodeArray: [],
      currentTicket: "",
      fcodeInputComplete: false,
      // ticket: ""
    };
  },
  computed: {
    ...mapState({
      isPC: (state) => state.isPC,
      isWeixin: (state) => state.isWeixin,
      isElectron: (state) => state.isElectron,
      user: (state) => state.user,
      guideType: (state) => state.guideType,
      canFree:state => state.canFree
    }),
    robotLabel() {
      let robotLabel = "";
      this.robotList.forEach((item, index) => {
        if (this.currentTicket == item.ticket) {
          robotLabel = `${item.label}${item.huyaUserName ? `-${item.huyaUserName}` : ""}`;
        }
      });
      return robotLabel;
    },
  },
  watch: {
    ticket(val) {
      this.currentTicket = val;
    },
    FCode(val) {
      if (inputFcodeTimer) {
        clearTimeout(inputFcodeTimer);
        inputFcodeTimer = null;
      }
      if (!val.length) {
        this.pName = "";
        this.fcodeInputComplete = false;
      } else {
        inputFcodeTimer = setTimeout(() => {
          this.getFCodeName();
        }, 2e3);
      }
    },
  },
  components: {
    // payBox
  },
  mounted() {
    this.currentTicket = this.user.ticket;
  },
  methods: {
    ...mapActions(["changeGuideType"]),
    getFCodeName() {
      if (this.FCode) {
        if (this.FCode.length == 32 || this.FCode.length == 10) {
          getFCode({
            fcode: this.FCode,
          }).then((res) => {
            if (res.code === 0) {
              if (res.data.pname) {
                this.pName = res.data.pname;
              } else {
                this.pName = "无效F码";
              }
            }
            this.fcodeInputComplete = true;
          });
        } else {
          this.pName = "F码位数错误";
          this.fcodeInputComplete = true;
        }
      } else {
        this.pName = "";
      }
    },
    handleRenew(index, data) {
      if (data.timeAdd > data.products.length) {
        this.$message.warning("请选择续费时间");
        return;
      }
      this.$emit(
        "orderPayShow",
        {
          pkey: data.products[data.timeAdd].pkey,
          num: 1,
          channel: "wx",
          type: this.isGuide ||  1,
          email: "",
          ticket: this.currentTicket,
          price: (data.products[data.timeAdd].price / 100).toFixed(1),
          productName: data.name,
        },
        "fcode"
      );
    },
    orderPayWeixinGuideShow() {
      this.$emit("orderPayWeixinGuideShow");
    },
    actionFCode(isEnd = true) {
      if (this.FCode.length != 32 && this.FCode.length != 10) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
        });
        return;
      }
      if (this.FCode) {
        if (this.isGuide) {
          getFCode({
            fcode: this.FCode,
          }).then((resp) => {
            if (resp.code === 0) {
              // if (resp.data.type == 'client' && !this.isElectron) {
              //   this.linkToNextGuideError()
              // } else {
              consumeFCode({
                fcode: this.FCode,
                ticket: this.currentTicket,
              }).then((res) => {
                if (res.code == 0) {
                  if (isEnd) {
                    this.linkToNextGuide();
                  }
                } else {
                  if (res.code == 20004) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
                    });
                    // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
                  }
                  if (res.code == 20005) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
                    });
                  }
                  if (res.code == 20006) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
                    });
                  }
                  if (res.code == 20007) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
                    });
                  }
                  if (res.code == 20008) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
                    });
                    if (this.isGuide) {
                      userInfo(null, { notify: false }).then((res) => {
                        if (res.code == -2050) {
                          localStorage.removeItem("sid");
                          if (
                            this.$route.path != "/agent" &&
                            this.$route.path != "/login"
                          ) {
                            this.$router.replace("/login");
                          }
                        } else {
                          if (res.data.activated) {
                            if (!res.data.guide) {
                              localStorage.removeItem("guidePage");
                              this.$router.replace({
                                name: "robotManager",
                                params: {
                                  type: "guide",
                                },
                              });
                            } else {
                              let path = ["/guideAccount", "/guideRate"];
                              this.$router.replace(path[res.data.guide - 2]);
                            }
                          } else {
                            this.$message({
                              showClose: true,
                              message: "你的账户未激活，请联系客服",
                              type: "error",
                            });
                          }
                        }
                      });
                    }
                  }
                  if (res.code == 20015) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
                    });
                  }
                  if (res.code == 20016) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
                    });
                  }
                  if (res.code == 20017) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      message:
                        '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
                    });
                  }
                }
              });
              // }
            }
          });
        } else {
          consumeFCode({
            fcode: this.FCode,
            ticket: this.currentTicket,
          }).then((res) => {
            if (res.code == 0) {
              this.FCode = "";
              this.pName = "";
              Message({
                showClose: true,
                message: "F码使用成功！",
                type: "success",
              });
              if (isEnd) {
                this.$emit("completeFcode");
              }
            } else {
              if (res.code == 20004) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
                });
                // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
              }
              if (res.code == 20005) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
                });
              }
              if (res.code == 20006) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
                });
              }
              if (res.code == 20007) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
                });
              }
              if (res.code == 20008) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
                });
              }
              if (res.code == 20015) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
                });
              }
              if (res.code == 20016) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
                });
              }
              if (res.code == 20017) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message:
                    '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
                });
              }
            }
          });
        }
      } else {
        Message({
          showClose: true,
          message: "请输入F码",
        });
      }
    },
    checkFcodeOrder(orderId) {
      checkFcodeOrder(
        {
          orderId: orderId,
        },
        { notify: false }
      ).then((res) => {
        if (res.code === 0) {
          if (res.data.paid) {
            this.FCodeArray = res.data.fcodes;
            this.actionFCodeArray();
          }
        }
      });
    },
    orderCheckResult(fcodes) {
      this.FCodeArray = fcodes;
      this.actionFCodeArray();
    },
    actionFCodeArray() {
      this.FCodeArray.forEach((val, index) => {
        setTimeout(() => {
          this.FCode = val.fcode;
          this.actionFCode(index == this.FCodeArray.length - 1);
          if (index == this.FCodeArray.length - 1) {
            this.FCodeArray = [];
          }
        }, 100);
      });
    },
    linkToNextGuide() {
      setGuide({
        guide: 2,
      }).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("guidePage", "/guideAccount");
          this.$router.replace({
            path: "/guideAccount",
          });
        }
      });
    },
    linkToNextGuideError() {
      this.$router.replace({
        path: "/guideError",
      });
    },
    dialogPayClose() {
      this.$refs.dialogpay.hideDialog();
    },
    payCompleted(fcode, pkey = "") {
      if (fcode && fcode.length) {
        this.FCodeArray = fcode;
        this.actionFCodeArray();
        // this.confirmConsumeFCode();
      } else {
        if (this.isGuide) {
          this.linkToNextGuide();
        } else {
          this.$emit("completeFcode");
        }
      }
    },
   async tryOut() {
      if (!this.isElectron) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>手机版不提供试用</strong><p style="margin-top: 5px;">手机版需要开销服务器，暂不提供试用</p>',
        });
      } else {
        let ret = await getThreeDayVip();
        if(ret && ret.code === 0){
          this.linkToNextGuide();
        }else if(ret && ret.message){
          this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>'+ret.message+'</p>',
        });
        }
      }
    },
    robotChange(val) {
      this.$emit("robotChange", val);
    },
    logout() {
      localStorage.removeItem("sid");
      localStorage.removeItem("avatar");
      localStorage.removeItem("user_name");
      this.$router.replace("/login");
    },
  },
};
</script>
